<script setup lang="ts">
const email = ref('')
const agreement = ref(false)
const interval = ref()
const isEmailValid = ref<string | boolean>(false)
const debounceTime = 400
const $t = useI18n().t
const notyf = useNotyfService()
const loader = ref(false)
const { emailRule } = useFormRulesService()
const localePath = useLocalePath()
const sendAnalyticsData = (submittedEmail: string) => {
	const gtmService = useGTMService()
	if (!gtmService) return
	gtmService.newsletterSubmit({ form_name: 'newsletter', form_email: submittedEmail, form_email_hash: hashEmail(submittedEmail) })
}

const subscribe = async () => {
	if (!agreement || !emailExists.value || isEmailValid.value !== true) return
	loader.value = true
	const submittedEmail = email.value

	try {
		await ApiService.newsletterSignup(email.value)
		notyf?.success($t('seccess.newsletter_subscribed'))
	} catch (error) {
		notyf?.error(error?.message)
		logger.error(error)
	} finally {
		loader.value = false
		email.value = ''
		agreement.value = false
	}

	sendAnalyticsData(submittedEmail)
}

const debouncedInputHandler = () => {
	isEmailValid.value = false
	clearInterval(interval.value)
	interval.value = setInterval(() => {
		clearInterval(interval.value)
		validateEmail()
	}, debounceTime)
}

const emailExists = computed(() => {
	return email.value && email.value !== ''
})

const validateEmail = () => {
	if (!emailExists.value) {
		isEmailValid.value = true
		return
	}
	const validation = emailRule(email.value)
	isEmailValid.value = validation
}
</script>

<template>
	<div class="newsletter">
		<p class="newsletter__title">{{ $t('components.footer.newsletter.title') }}</p>
		<p class="newsletter__text">{{ $t('components.footer.newsletter.text') }}</p>
		<div style="position: relative">
			<v-text-field
				id="newsletter-email"
				v-model="email"
				class="newsletter__text-field"
				:label="`${$t('components.footer.newsletter.email_label')}*`"
				:error-messages="isEmailValid === true || isEmailValid === false ? undefined : isEmailValid"
				variant="solo"
				density="comfortable"
				@input="debouncedInputHandler"></v-text-field>
			<ButtonPrimary
				class="newsletter__btn"
				size="small"
				:disabled="!agreement || !emailExists || isEmailValid !== true || loader"
				:loading="loader"
				@click="subscribe"
				>{{ $t('components.footer.newsletter.button_text') }}</ButtonPrimary
			>
		</div>
		<div class="newsletter__checkbox">
			<GlobalCheckbox v-model="agreement">
				<span>{{ $t('modules.reservation_module.reservation.agreements.processing_my_personal_data') }}</span>
				<a :href="localePath('privacy-policy')" rel="nofollow" target="_blank">{{
					$t('modules.reservation_module.reservation.agreements.privacy_policy')
				}}</a>
				<span>{{ $t('modules.reservation_module.reservation.agreements.processing_my_personal_data_2') }}</span
				><Asterix />
			</GlobalCheckbox>
		</div>
		<Transition name="fade" mode="out-in">
			<div v-if="!agreement && emailExists && isEmailValid === true" class="newsletter__fill-all-fields">
				{{ $t('common.fill_all_fields_star') }}(*)
			</div>
		</Transition>
	</div>
</template>

<style scoped lang="scss" src="./Newsletter.scss"></style>
